import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './index.css';

export type ITagProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

export class Tag extends React.PureComponent<ITagProps, {}> {
  public render() {
    const { children, className } = this.props;

    return (
      <span {...this.props} {...mergeStyles(styles['tag'], className)}>
        {children}
      </span>
    );
  }
}
